import {t} from '../../../common/getTranslations';
import {Icon} from '../../atoms/Icon/Icon';
import {IconType} from '../../atoms/Icon/IconType.enum';
import {Text} from '../../atoms/Text/Text';
import {ViewerGuideProps} from './ViewerGuideProps.interface';
import {ViewerGuideType} from './ViewerGuideType.enum';

export function ViewerGuide({viewerGuideType}: ViewerGuideProps) {
  return (
    <div className="flex h-94pxr w-94pxr flex-col items-center justify-center space-y-8pxr rounded-3pxr bg-static-mono-90">
      <>
        <Icon
          type={ViewerGuideTypeToIconType(viewerGuideType)}
          disableActiveEffect
        />
      </>
      <Text className="font-small1-bold text-static-mono-white">
        {ViewerGuideTypeToString(viewerGuideType)}
      </Text>
    </div>
  );
}

function ViewerGuideTypeToIconType(viewerGuideType: ViewerGuideType): IconType {
  switch (viewerGuideType) {
    case ViewerGuideType.Forward:
      return IconType.ViewerGuideArrowRightStatic;
    case ViewerGuideType.Reverse:
      return IconType.ViewerGuideArrowLeftStatic;
    case ViewerGuideType.Scroll:
      return IconType.ViewerGuideArrowDownStatic;
    case ViewerGuideType.Tap:
      return IconType.ViewerGuideTouchStatic;
  }
}
function ViewerGuideTypeToString(viewerGuideType: ViewerGuideType): string {
  switch (viewerGuideType) {
    case ViewerGuideType.Forward:
      return t('viewer_paging_toast');
    case ViewerGuideType.Reverse:
      return t('viewer_paging_toast_2');
    case ViewerGuideType.Scroll:
      return t('viewer_setting_mode_scroll_button');
    case ViewerGuideType.Tap:
      return t('viewer_tap_toast');
  }
}
